export default {
  methods: {
    getYoutubeId(input) {
      if (!input || typeof input !== 'string') return null;

      const trimmedInput = input.trim();

      // 1. Якщо це вже чистий ID (11 символів)
      if (/^[a-zA-Z0-9_-]{11}$/.test(trimmedInput)) {
        return trimmedInput;
      }

      try {
        const urlString = trimmedInput.startsWith('http') 
          ? trimmedInput 
          : `https://${trimmedInput}`;
        
        const url = new URL(urlString);
        const host = url.hostname.replace('www.', '');
        const pathname = url.pathname;

        // СУВОРА ПЕРЕВІРКА: Ігноруємо YouTube Music
        if (host === 'music.youtube.com') return null;

        // Обробка основного домену youtube.com та мобільної версії m.youtube.com
        if (host === 'youtube.com' || host === 'm.youtube.com') {
          // Стандартне відео: watch?v=ID
          if (url.searchParams.has('v')) {
            return url.searchParams.get('v');
          }

          // Спеціальні формати: Shorts, Live, Embed
          const paths = ['/shorts/', '/live/', '/embed/', '/v/'];
          for (const p of paths) {
            if (pathname.startsWith(p)) {
              return pathname.slice(p.length).split(/[?/]/)[0];
            }
          }
        }

        // Коротки посилання: youtu.be/ID
        if (host === 'youtu.be') {
          return pathname.slice(1).split(/[?/]/)[0];
        }
      } catch (e) {
        // Якщо URL невалідний — ігноруємо
      }

      // 2. Резервний пошук (тільки якщо в рядку є ознаки відео-хостингу)
      // Ми виключаємо music з регулярки
      if (trimmedInput.includes('music.youtube.com')) return null;

      const videoRegex = /(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([a-zA-Z0-9_-]{11})/;
      const match = trimmedInput.match(videoRegex);

      return match ? match[1] : null;
    },
  },
};
